import React, { useMemo, useCallback } from "react"
import PropTypes from "prop-types"
import { Transition } from "react-transition-group"
import gsap from "gsap"
import style from "./Background.module.css"

// import buddy1 from "../../assets/images/buddies/1.png"
// import buddy2 from "../../assets/images/buddies/2.png"
// import buddy3 from "../../assets/images/buddies/3.png"
// import buddy4 from "../../assets/images/buddies/4.png"
// import buddy5 from "../../assets/images/buddies/5.png"
// import buddy6 from "../../assets/images/buddies/6.png"

import { COLOUR_PALETTES } from "../../styles/ColourPalettes"

// The background component contains different states for sections of the page
// There is either a triggered transition that plays to completion for a short direction
// Or a scroll (progress) controlled tween
// Each background is mounted/unmounted and transitioned to at the appropriate position.
const Background = props => {
  const { sectionIndex, windowDimensions } = props

  const matchesEnter = useCallback(node => {
    // Set the fields down and out
    gsap.set(".matchCircle", {
      autoAlpha: 0,
      x: "random(-420, 420,10)",
      y: "random(-420, 420,10)",
    })
  }, [])

  const matchesTransition = useCallback(
    (node, done) => {
      if (sectionIndex === 1) {
        console.log("Matches entering")
        // Entering
        gsap.to(".matchCircle", {
          duration: 3,
          autoAlpha: 0.04,
          x: 0,
          y: 0,
          onComplete: () => done(),
        })
      } else {
        console.log("Matches exiting")
        // Exiting
        gsap.to(".matchCircle", {
          duration: 1,
          autoAlpha: 0,
          x: "random(-200, 200,1)",
          y: "random(-200, 200,1)",
          onComplete: () => done(),
        })
      }
    },
    [sectionIndex]
  )

  const matchCircleColours = useMemo(() => {
    const array = new Array(16).fill("") // 9 pairs of colours for each match pair
    let colours = []
    array.forEach((_, index) => {
      const randomIndex = gsap.utils.random(
        0,
        Object.values(COLOUR_PALETTES).length - 1,
        1
      )
      const randomColour = Object.values(COLOUR_PALETTES)[randomIndex][0]

      if (index % 2) {
        colours.push([randomColour, "#09CCC4"])
      } else {
        colours.push(["#09CCC4", randomColour])
      }
    })
    return colours
  }, [])

  const returnMatchCircles = index => {
    return (
      <div className={style.match}>
        <div
          className="matchCircle"
          style={{
            backgroundColor: matchCircleColours[index][0],
          }}
        />
        <div
          className="matchCircle"
          style={{ backgroundColor: matchCircleColours[index][1] }}
        />
      </div>
    )
  }

  // Buddies Round Table
  const buddiesEnter = useCallback(node => {
    // Set the fields down and out
    gsap.set(".buddy", { scale: 2, autoAlpha: 0 })
  }, [])

  const buddiesTransition = useCallback(
    (node, done) => {
      if (sectionIndex === 2) {
        console.log("Buddies BG entering")
        // Entering
        gsap.to(".buddy", {
          duration: 2,
          autoAlpha: 0.06,
          scale: 1,
          stagger: 0.1,
          onComplete: () => done(),
        })
      } else {
        console.log("Buddies BG Exiting")
        // // Exiting (scrolling up)
        gsap.to(".buddy", {
          duration: 1,
          autoAlpha: 0,
          y: 0,
          onComplete: () => done(),
        })
      }
    },
    [sectionIndex]
  )

  // Use Media and set variety of sizes / DO in CSS
  const buddySize = Math.round(windowDimensions.height / 6)
  const returnBuddies = () => {
    const array = new Array(9).fill("")
    return (
      <div
        className={style.buddiesWrapper}
        style={{ width: buddySize, height: buddySize }}
      >
        {array.map((_, index) => {
          return (
            <div
              key={index}
              className={["buddy", style.buddy].join(" ")}
              style={{
                width: buddySize,
                height: buddySize,
                transform: `rotateZ(${(360 / array.length) *
                  index}deg) translateY(${buddySize * 2}px)`,
                transformOrigin: `50% 50%`,
                backgroundColor: COLOUR_PALETTES[index * 40][0],
              }}
            />
          )
        })}
      </div>
    )
  }

  // const returnWindowCenter = targetRect => {
  //   const targetTop = windowDimensions.height / 2 - targetRect.height / 2
  //   const targetLeft = windowDimensions.width / 2 - targetRect.width / 2
  //   return { y: targetTop, x: targetLeft }
  // }

  // const returnBuddyTranslation = target => {
  //   // Scale down the circle and translate to center of the screen
  //   // Half the window dimensions
  //   console.log("returnBuddyTranslation")
  //   const targetRect = target.getBoundingClientRect()
  //   const centerPoints = returnWindowCenter(targetRect)
  //   return {
  //     y: centerPoints.y - targetRect.y,
  //     x: centerPoints.x - targetRect.x,
  //   }
  // }

  // Section 2 -- Match Circles

  // Use GSAP3 Random function

  return (
    <>
      <div className={style.container}>
        {/* Personal Section */}
        {/* Rows of coloured circles are scrolling horizontally at different speeds */}
        {/* <Transition
          mountOnEnter={true}
          unmountOnExit={true}
          in={sectionIndex === 0}
          onEnter={node => colouredCirclesEnter(node)}
          addEndListener={(node, done) => colouredCirclesTransition(node, done)}
        >
          <div id="colours" className={style.colours}>
            <div>{returnColouredCircleRows(100)}</div>
            <div>{returnColouredCircleRows(101)}</div>
            <div>{returnColouredCircleRows(100)}</div>
            <div>{returnColouredCircleRows(101)}</div>
          </div>
        </Transition> */}

        {/* Overlapping circles for matches */}
        <Transition
          mountOnEnter={true}
          unmountOnExit={true}
          in={sectionIndex === 1}
          onEnter={node => matchesEnter(node)}
          addEndListener={(node, done) => matchesTransition(node, done)}
        >
          <div className={style.matches}>
            <div>
              {returnMatchCircles(0)}
              {returnMatchCircles(1)}
              {returnMatchCircles(2)}
              {returnMatchCircles(3)}
            </div>
            <div>
              {returnMatchCircles(4)}
              {returnMatchCircles(5)}
              {returnMatchCircles(6)}
              {returnMatchCircles(7)}
            </div>
            <div>
              {returnMatchCircles(8)}
              {returnMatchCircles(9)}
              {returnMatchCircles(10)}
              {returnMatchCircles(11)}
            </div>
            <div>
              {returnMatchCircles(12)}
              {returnMatchCircles(13)}
              {returnMatchCircles(14)}
              {returnMatchCircles(15)}
            </div>
          </div>
        </Transition>

        {/* Buddies section the buddy avatars */}
        <Transition
          mountOnEnter={true}
          unmountOnExit={true}
          in={sectionIndex === 2}
          onEnter={node => buddiesEnter(node)}
          addEndListener={(node, done) => buddiesTransition(node, done)}
        >
          <div id="buddies" className={style.buddies}>
            {returnBuddies()}
          </div>
        </Transition>
      </div>
    </>
  )
}

Background.propTypes = {
  sectionIndex: PropTypes.number.isRequired,
  windowDimensions: PropTypes.object.isRequired,
}

export default Background

// Section 0 - Coloured Circles
// const colouredCirclesEnter = useCallback(node => {
//   // Set the fields down and out
//   gsap.set(".colour", { opacity: 0, scale: 2 })
// }, [])

// const colouredCirclesTransition = (node, done) => {
//   if (sectionIndex === 0) {
//     console.log("Colours BG entering")
//     // Entering
//     gsap.to(".colour", {
//       duration: 3,
//       opacity: 0.06,
//       scale: 1,
//       onComplete: () => done(),
//     })
//   } else {
//     console.log("Colours BG exiting")
//     // Exiting to next section (1)
//     gsap.to(".colour", {
//       duration: 1,
//       scale: 0,
//       opacity: 0,
//       onComplete: () => done(),
//     })
//   }
// }

// const colouredCircleColours = useMemo(() => {
//   const array = new Array(101).fill("")
//   let colours = []
//   array.forEach(_ => {
//     // const colourIndex = index % Object.values(COLOUR_PALETTES).length
//     const colourIndex = Math.floor(
//       Math.random() * Math.floor(Object.values(COLOUR_PALETTES).length - 1)
//     )
//     const colour = Object.values(COLOUR_PALETTES)[colourIndex][0]
//     colours.push(colour)
//   })
//   return colours
// }, [])

// const returnColouredCircleRows = (count = 100) => {
//   const array = new Array(count).fill("")
//   return array.map((_, index) => {
//     return (
//       <div
//         key={index}
//         className={["colour", style.colour].join(" ")}
//         style={{ backgroundColor: colouredCircleColours[index] }}
//       />
//     )
//   })
// }
